'use client';

import { JSX } from 'react';

export default function LocalDate({ isoDate }: { isoDate: string }): JSX.Element {
    const date = new Date(isoDate);
    if (isNaN(date.getTime())) {
        return <>Invalid Date</>;
    }
    const dateStr = date.toDateString();
    const timeStr = date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', timeZoneName: 'short' });
    return (
        <>
            {dateStr} at {timeStr}
        </>
    );
}
